export const translations = {
  'sv': {
    menuHomeButton: 'Hem',
    menuGoBackButton: 'Gå tillbaka',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
    navLabel: 'Huvudnavigation',
  },
  'en': {
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Main navigation',
  },
  'da': {
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbage',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Hovednavigation',
  },
  'no': {
    menuHomeButton: 'Hjem',
    menuGoBackButton: 'Gå tilbake',
    mainMenuButton: 'Meny',
    menuStartButton: 'Start',
    navLabel: 'Hovednavigasjon',
  },
  'de': {
    menuHomeButton: 'Home',
    menuGoBackButton: 'Geh zurück',
    mainMenuButton: 'Menü',
    menuStartButton: 'Start',
    navLabel: 'Hauptnavigation',
  },
  'zh': {
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Main navigation',
  },
  'it': {
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Main navigation',
  },
  'nl': {
    menuHomeButton: 'Home',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Main navigation',
  },
  'tr': {
    menuHomeButton: 'Anasayfa',
    menuGoBackButton: 'Geri git',
    mainMenuButton: 'Menü',
    menuStartButton: 'Başlat',
    navLabel: 'Ana gezinme',
  },
  'pt': {
    menuHomeButton: 'Página inicial',
    menuGoBackButton: 'Go back',
    mainMenuButton: 'Menu',
    menuStartButton: 'Start',
    navLabel: 'Main navigation',
  },
  'pl': {
    menuHomeButton: 'Strona główna',
    menuGoBackButton: 'Powrót',
    mainMenuButton: 'Menu',
    menuStartButton: 'Początek',
    navLabel: 'Menu główne systemu',
  },
  'pt-BR': {
    menuHomeButton: 'Página inicial',
    menuGoBackButton: 'Voltar',
    mainMenuButton: 'Menu',
    menuStartButton: 'Iniciar',
    navLabel: 'Navegação principal',
  },
};
